export default
{
    computed:
    {
        from()
        {
            return this.modelValue.from !== undefined ? this.modelValue.from : this.min;
        },

        to()
        {
            return this.modelValue.to !== undefined ? this.modelValue.to : this.max;
        },

        fromPosition()
        {
            return ( this.from - this.min ) / ( this.max - this.min );
        },

        toPosition()
        {
            return ( this.to - this.min ) / ( this.max - this.min );
        },

        fromInputValue:
        {
            get()        { return this.modelValue.from },
            set( value ) { this.emitValue({ from: value, to: this.modelValue.to }) }
        },

        toInputValue:
        {
            get()        { return this.modelValue.to },
            set( value ) { this.emitValue({ from: this.modelValue.from, to: value }) }
        },

        progressFillPosition()
        {
            return (
            {
                '--range-selection-left'  : `calc( ${ this.fromPosition } * ( 100% - var( --range-handle-size ) * 2 ) + ( var( --range-handle-size ) / 2 ) )`,
                '--range-selection-right' : `calc( ${ 1 - this.toPosition } * ( 100% - var( --range-handle-size ) * 2 ) + ( var( --range-handle-size ) / 2 ) )`
            })
        },

        fromHandlePosition()
        {
            return (
            {
                left: `calc(${ this.fromPosition } * ( 100% - var( --range-handle-size ) * 2 ) )`
            });
        },

        toHandlePosition()
        {
            return (
            {
                left: `calc(${ this.toPosition } * ( 100% - var( --range-handle-size ) * 2 ) + var( --range-handle-size ) )`
            });
        },

        scope()
        {
            return(
            {
                range:
                {
                    attributes:
                    {
                        class:
                        {
                            'vr-show-label'     : this.showLabels,
                            'vr-disabled'       : this.disabled,
                            'vr-input-mode'     : this.mode === 'input',
                            [this.class]        : this.class
                        },

                        style:
                        {
                            ...this.progressFillPosition
                        }
                    }
                },

                input:
                {
                    from:
                    {
                        listeners:
                        {
                            keydown: ( event ) => this.handleInputKeyDown( 'from', event )
                        }
                    },

                    to:
                    {
                        listeners:
                        {
                            keydown: ( event ) => this.handleInputKeyDown( 'to', event )
                        }
                    }
                },

                handle:
                {
                    style:
                    {

                    },

                    attributes:
                    {
                        class:
                        {
                            'vr-show-label': this.showLabels
                        }
                    }
                }
            })
        }
    }
}